var module = angular.module('octopusApp.projects');

module.controller('StepListController', function ($scope, busy, $uibModalInstance, steps, action) {
  $scope.steps = steps;
  $scope.action = action;
  $scope.selectedStep = null;

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function (selected) {
    $uibModalInstance.close($scope.selectedStep);
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_step_list_controller.js
// module id = 527
// module chunks = 1